<footer class="footer">
  <div class="footer-content justify-content-center align-items-center">
    <span>© 2016 Fincorp. All right reserved.</span>
  </div>
</footer>
